import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/advantages',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <HomePage />,
  },
  {
    path: '/partners',
    element: <HomePage />,
  },
  {
    path: '/solutions',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <HomePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;